import { render, staticRenderFns } from "./Acts.vue?vue&type=template&id=1872c207&scoped=true&"
import script from "./Acts.vue?vue&type=script&async=true&lang=js&"
export * from "./Acts.vue?vue&type=script&async=true&lang=js&"
import style0 from "./Acts.vue?vue&type=style&index=0&id=1872c207&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1872c207",
  null
  
)

export default component.exports